var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PostGrid',{attrs:{"title":"Recent Posts","fetchUrl":_vm.constants.apiBaseUrl + _vm.constants.apiGetLatestsPath + 12}})
}
var staticRenderFns = []

export { render, staticRenderFns }